/**
 * Wraps a string treating it as a GraphQL Enum. These will not be
 * wrapped in quotes when injected into argument lists.
 */
export default class EnumValue<
  T extends string = string,
  V extends string = string
> {
  type: T;
  value: V;

  constructor(type: T, value: V) {
    this.type = type;
    this.value = value;
  }

  toString() {
    return this.value;
  }

  toJSON() {
    return this.toString();
  }

  equals(other: EnumValue<string, string>) {
    return this.type === other.type && this.value === other.value;
  }
}
